import { render, staticRenderFns } from "./wholeMentoringInfo.vue?vue&type=template&id=6e9ba893&scoped=true&"
import script from "./wholeMentoringInfo.vue?vue&type=script&lang=js&"
export * from "./wholeMentoringInfo.vue?vue&type=script&lang=js&"
import style0 from "./wholeMentoringInfo.vue?vue&type=style&index=0&id=6e9ba893&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e9ba893",
  null
  
)

export default component.exports